import HttpService from 'services/http.service';
import { MidasProductIntervals } from 'app/api/espresso/midas-product/[promotionCode]/route';

export const fetchIntervalUnitAndCount = async (promotionCode: string) => {
  const url = `/api/espresso/midas-product/${promotionCode}`;

  const response = await HttpService.getInstance().get<MidasProductIntervals[]>(
    url,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!response?.data || response.status !== 200) {
    throw new Error(
      `Failed to retrieve additional midas product details in strapi from ${url}, ${response?.error}`,
    );
  }

  return response.data;
};
